import React from "react";
import { Link } from "react-router-dom";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "../../index.scss";
import "./Responsive.scss";
import "./Centralpart.scss";
import "./Centralpartimages.scss";

const imLN = [
  {
    slug: "oktobarski-salon",
    title: "Oktobarski salon",
    im: "oktobarski_salon_mala.png",
  },
  {
    slug: "petar-lubarda",
    title: "petar lubarda",
    im: "lubarda_mala.jpg",
  },
  {
    slug: "sava-sumanovic",
    title: "sava sumanovic",
    im: "slikar_2_mala.jpg",
  },
  {
    slug: "muzej-savremene-umetnosti",
    title: "muzej savremene umetnosti",
    im: "exterijer1_mala.gif",
  },
  {
    slug: "avangarda",
    title: "avangarda",
    im: "04_avangarda_mala_01.jpg",
  },
  {
    slug: "nadezda-petrovic",
    title: "nadezda petrovic",
    im: "nadezda-petrovic-m_01.jpg",
  },
  {
    slug: "",
    title: "",
    im: "slikar_4_mala.jpg",
  },
  {
    slug: "",
    title: "",
    im: "slikar_5_mala.jpg",
  },
  {
    slug: "",
    title: "",
    im: "slikar_6_mala.jpg",
  },
];

const imLCN = imLN.map((val, ind) => {
  const linkVal = val["slug"] != "" ? "/g/" + val["slug"] : "#";
  const srcVal = "./images/" + val["im"];
  const titleVal = val["title"] != "" ? val["title"] : "";
  const altVal = val["title"] != "" ? val["title"] : "umetnik";
  return (
    <Link className="imLink" to={linkVal} key={ind}>
      <img src={srcVal} title={titleVal} alt={altVal} />
      <div></div>
    </Link>
  );
});

const Centralpartimages = () => (
  <div className="photo-art">
    <Col
      sm={{ span: 12 }}
      md={{ span: 11, offset: 1 }}
      lg={{ span: 12, offset: 0 }}
      xl={{ span: 12, offset: 0 }}
    >
      <Row>
        <div className="central-images">{imLCN}</div>
      </Row>
    </Col>
  </div>
);

export default Centralpartimages;
